const hydrate = (options) => {
  const router = options?.router;
  if (!router) {
    console.warn("hydratePageLinks called without router");
    return false;
  }
  const links = document.querySelectorAll(
    `[data-scalar-type="page-link"]`
  );
  links.forEach((element) => {
    if (!element.hasAttribute("hydration-has-listener")) {
      const id = element.dataset.linkId;
      element.addEventListener("click", () => {
        if (id) router.push({ name: id });
      });
      element.setAttribute("hydration-has-listener", "true");
    }
  });
  return true;
};
export {
  hydrate
};
//# sourceMappingURL=hydration.js.map
